"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _GlobalClick = _interopRequireDefault(require("@insided/shared/uikit/GlobalClick"));

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

var _DynamicImport = _interopRequireDefault(require("@insided/shared/utils/DynamicImport"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SketchPicker = (0, _DynamicImport.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
  var _yield$import, SketchPicker;

  return _regenerator.default.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return import('react-color');

        case 2:
          _yield$import = _context.sent;
          SketchPicker = _yield$import.SketchPicker;
          return _context.abrupt("return", {
            default: SketchPicker
          });

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})));

var ColorSelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ColorSelector, _Component);

  var _super = _createSuper(ColorSelector);

  function ColorSelector() {
    var _this;

    (0, _classCallCheck2.default)(this, ColorSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      enablePicker: false
    });
    return _this;
  }

  (0, _createClass2.default)(ColorSelector, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          meta = _this$props.meta,
          selectedColor = _this$props.selectedColor,
          className = _this$props.className,
          onCallback = _this$props.onCallback,
          dropdownClass = _this$props.dropdownClass;
      var enablePicker = this.state.enablePicker;
      return (0, _preact.h)(_GlobalClick.default, {
        onGlobalClick: function onGlobalClick() {
          _this2.setState({
            enablePicker: false
          });
        },
        class: className
      }, (0, _preact.h)("div", {
        onClick: function onClick() {
          return _this2.setState({
            enablePicker: true
          });
        }
      }, (0, _preact.h)("label", null, title), meta && (0, _preact.h)("div", null, meta), (0, _preact.h)("div", {
        className: "form-group form-control"
      }, (0, _preact.h)("span", {
        className: "default-header_colors-visual"
      }, (0, _preact.h)("span", {
        style: {
          backgroundColor: selectedColor
        },
        className: "default-header_colors-preview"
      }), (0, _preact.h)("span", {
        className: "color-selector_selected-color"
      }, selectedColor)), (0, _preact.h)(_buttonControl.default, {
        icon: "arrowDropdown",
        class: dropdownClass
      }), (0, _preact.h)("span", {
        className: "default-header_colors-picker-container"
      }, enablePicker ? (0, _preact.h)(SketchPicker, {
        disableAlpha: true,
        color: selectedColor,
        onChangeComplete: function onChangeComplete(_ref2) {
          var hex = _ref2.hex;
          return onCallback(hex);
        }
      }) : null))));
    }
  }]);
  return ColorSelector;
}(_preact.Component);

var _default = ColorSelector;
exports.default = _default;